import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconInbox(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M5 21c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 19V5c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 3h14c.55 0 1.02.196 1.413.587C20.803 3.98 21 4.45 21 5v14c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 21H5Zm0-2h14v-3h-3a5.32 5.32 0 0 1-1.787 1.475c-.692.35-1.43.525-2.213.525-.783 0-1.52-.175-2.213-.525A5.321 5.321 0 0 1 8 16H5v3Zm7-3c.533 0 1.025-.137 1.475-.412.45-.275.817-.638 1.1-1.088.1-.15.225-.27.375-.363a.94.94 0 0 1 .5-.137H19V5H5v9h3.55a.94.94 0 0 1 .5.137c.15.092.275.213.375.363.283.45.65.813 1.1 1.088.45.275.942.412 1.475.412Z"
      />
    </BaseIcon>
  );
}
